import RingBufferGeometry from 'src/components/Stage/question/RingBufferGeometry'

import EventEmitter from 'src/helpers/EventEmitter'
import { DEG_TO_RAD } from 'src/helpers/MathUtils'

import store from 'src/store'

const THREE = require('three')
  
class Circles extends THREE.Group { 

  constructor(config) {

    super();
  
    Object.assign(this, EventEmitter)  
    
    this.materials = config.materials;
    this.tweenObj = { 
      scale: 0.01
    }

    // MESH     
    this.visible = false;
    this.position.y = 50;
    this.position.z = -240;
    this.scale.x = this.scale.y = this.scale.z = 1.2;
    this.setup(); 

    // START
    this.resize() 
  }

  setup() { 
    for (var i = 0; i < 8; i++) {
      let scale = 1 + (i / 4);
      var geometry = new RingBufferGeometry( 120 * scale, 140 * scale, 50, 0, Math.PI * 0.5);
      let material = this.materials[Math.round(Math.random() * 3)]; 
      var mesh = new THREE.Mesh( geometry, material);
      mesh.scale.tg = scale;
      mesh.scale.x = mesh.scale.y = 4;
      mesh.rotation.z = 360 * Math.random() * DEG_TO_RAD;
      mesh.position.z = -i * 10;
      this.add( mesh ); 
    }
  }

  updateRoute(val) {
    // switch(val.name) { 
    //   case 'question':
    //     this.visible = true;
    //     break; 
    //   default:
    //     this.visible = false;
    // }
  } 

  tick() {
    for (var i = 0; i < this.children.length; i++) {
      let child = this.children[i];  
      child.rotation.z -= (((child.scale.tg + i) * 0.001 ) * this.tweenObj.scale);  
    } 
  }

  idle() { 
    this.visible = false;
  }

  tapholdProgress() {  }
  
  tapholdRecord() {
    this.visible = true;
  }

  tapholdRelease() { }
    
  processing() {

    TweenMax.to(this.tweenObj, 2, {
      scale: 1,
      ease: 'Power2.easeOut'
    });

    for (var i = 0; i < this.children.length; i++) {
      let child = this.children[i];  
      TweenMax.to(child.scale, 1.3, {
        x: 1,
        y: 1,
        delay: 0.05 * i ,
        ease: 'Back.easeOut'
      });
    } 
  }
    
  complete() {
    TweenMax.to(this.tweenObj, 3, {
      scale: 0.01,
      ease: 'Power3.easeIn'
    });

    for (var i = 0; i < this.children.length; i++) {
      let child = this.children[i];  
      TweenMax.to(child.scale, 1, {
        x:4,
        y:4,
        delay: 0.05 * i,
        ease: 'Power2.easeIn',
        onComplete: () => {
          this.visible = false;
        }
      });
    }
  }

  result(val){}

   
 
  resize() {   }
 
 
}

export default Circles